export default (contents, key) =>
  contents.reduce(
    (acc, currentValue) => ({
      ...acc,
      [currentValue.path]: currentValue[key]
    }),
    {}
  );
